import React, { useContext, useEffect, useState } from 'react';
import { systemCode, xs_languageCode } from '../..';
import { BetslipContext } from '../../data/betslip/BetslipConf';
import FastbetCartContext from '../../data/fastbet/FastbetCartContext';
import { ShopContext } from '../../data/shop/ShopConf';
import { getAggregationAndBetFromBetIdAndSportId } from '../../data/utils/getAggregationAndBetFromBetIdAndSportId';
import { getBetDescription } from '../../data/utils/getBetDescription';
import { getConfiguration } from '../../data/utils/configuration';
import { oddToString } from '../../data/utils/oddToString';
import { labels } from '../../data/labels';

function f2handler(event) {
    if (event.which == 113) { //F2
        document.getElementById('fastbet-cart-event').focus();
        return false;
    }
}

function setFastbetCartEventListeners(goToAmountFieldChar) {
    document.removeEventListener('keydown', f2handler, true);
    document.addEventListener('keydown', f2handler, true);
    
    if (goToAmountFieldChar) {
        window.goToAmountFieldChar = goToAmountFieldChar;
        document.removeEventListener('keydown', window.handlerGoToAmountField, true);
        document.addEventListener('keydown', window.handlerGoToAmountField, true);  		 
    } else {
        document.removeEventListener('keydown', window.handlerGoToAmountField, true);
        window.goToAmountFieldChar = null;
    }
}

function FastbetCart(props) {
	const betslipContext = useContext(BetslipContext) ;
	const shopContext = useContext(ShopContext);
    const fastbetContext = useContext(FastbetCartContext);
    
    const eventSelector = React.useRef();
    const eventBetInput = React.useRef();
    const eventBetSelector = React.useRef();
    const conf = getConfiguration();
    const goToAmountFieldChar = conf.gtak;
    const fastbetType = fastbetContext.fastbetType;
    let matchFieldValue = fastbetContext.getMatchFieldText();

    // list of bets linked to the selected match
    let betList = fastbetContext.getBetList();
    betList = betList == null? [] : betList;
    matchFieldValue = matchFieldValue == null? "": matchFieldValue;

    useEffect(() => {
        if (betList?.length > 0 && window.eventsBuffer) {
            // If we're here it means that the user started typing before the data was loaded
            // and the typing stopped before the loading finished.
            // Now that the data is ready, we replay the keystrokes.
            const events = window.eventsBuffer;
            window.eventsBuffer = [];
            events.forEach(e => handleKeyDrawAlias(e));
        }
    }, [betList]);
    

    useEffect(function() {
    	let matchHasBeenSelected = fastbetContext.getSelectedMatch() != null;
   	 	if(matchHasBeenSelected){
   	 		// match has been selected: switching focus to the bet alias field
   	 		eventBetInput.current.focus();
   	 	}
   	 	setFastbetCartEventListeners(shopContext.enabled? goToAmountFieldChar : null); // F2 and + or * listeners. Defined in betslip-observers	 
   });
    
   /* TYPE OF FASTBET AND HOW THEY WORK
    * 
    * XR (for retail use):
    *  - events are sorted in a map indexes by event alias. The user types an alias in the first input and "Enter": we take the event from the above map and retreive its data from
    *    the backend, in order to build the market autocomplete stuff (2th input)
    */
    
    const betListToRender = [];
    const useCustomizedAlias = betslipContext.enableCustomAliases; 

    for(let k in betList){
    	let nativeBet = betList[k];	
    	const draws = [];
		const sportId = fastbetContext.selectedMatch.sportRef;
		let containerAggMarket = getAggregationAndBetFromBetIdAndSportId(sportId, nativeBet.cs, nativeBet.h);
		if(!containerAggMarket.aggregation && nativeBet.h != 0){
			containerAggMarket = getAggregationAndBetFromBetIdAndSportId(sportId, nativeBet.cs, 0);
		}
		if(containerAggMarket.market){
	    	let descBet = containerAggMarket.market.desc;
	    	if(containerAggMarket.market.hideHandicap){
	    		descBet = containerAggMarket.aggregation.descrizione;
	    	}
	    	else{
				descBet = getBetDescription({...nativeBet, ...containerAggMarket.market}, false, sportId);
			}
	    	for(let ke in nativeBet.eqs){
	    		const nativeDraw = nativeBet.eqs[ke];
	    		for(let kea in containerAggMarket.market.odds){
	    			const aggregateDraw = containerAggMarket.market.odds[kea];
	    			if(aggregateDraw.id == nativeDraw.ce){
	    				let odd = nativeDraw.q;
		    			if(nativeDraw.qps && nativeDraw.qps[systemCode]){
		    				odd = nativeDraw.qps;
		    			}
			    		if(odd > 100){
			    			const descDraw = containerAggMarket.market.hideHandicap? containerAggMarket.market.desc : aggregateDraw.desc;
				    		let aliasList = [];
				    		// checking if there is an alias customization for this skin
				    		if(useCustomizedAlias){
				    			let customizedAliasList = aggregateDraw.aliasBySystemCode? aggregateDraw.aliasBySystemCode[systemCode] : null;
				    			
				    			if((customizedAliasList == null || customizedAliasList.length === 0) && aggregateDraw.aliasHandicapBySystemCode){
				    				// searching it in the aliasByHandicapSystemCodeMap
				    				const keyMap = systemCode + "_" + nativeBet.h;
				    				customizedAliasList = aggregateDraw.aliasHandicapBySystemCode[keyMap];
				    			}
				    			if(customizedAliasList && customizedAliasList.length > 0){
				    				aliasList = customizedAliasList;
				    			}
				    		}
				    		else {
				
				    			if(aggregateDraw.aliasListDefault != null && aggregateDraw.aliasListDefault.length > 0){	
				    				aliasList = aggregateDraw.aliasListDefault;	
				        		}
				    			else if(aggregateDraw.aliasByHandicap != null && aggregateDraw.aliasByHandicap[nativeBet.h] != null){
				    				aliasList = aggregateDraw.aliasByHandicap[nativeBet.h];
				    			}
				    		}
			    			const draw = {
			    				odd,
			    				id : nativeDraw.ce,
			    				descDraw,
			    				aliasList
			    			};
				    		draws.push(draw);
			    		}
    				}
	    		}
	    	}
	    	if(draws.length > 0){
	    		let betRanking = 0;
	    		if(containerAggMarket.aggregation){
	    			betRanking = containerAggMarket.aggregation.ranking != null? containerAggMarket.aggregation.ranking : 0;
	    		}
	    		betRanking += containerAggMarket.market.ranking;
	    		const parsedBet = {
	    			scomSogei : nativeBet.cs,
	    			handicap : nativeBet.h,
	    			maxg : nativeBet.maxg,
	    			ming : nativeBet.ming,
	    			legabile: containerAggMarket.market.legabile,
	    			descBet,
	    			draws,
	    			ranking : betRanking
	    		};
	    		betListToRender.push(parsedBet);
	    	}		
		}
    }

    betListToRender.sort(function(betA, betB){
    	if(betA.ranking < betB.ranking) return -1;
    	if(betA.ranking > betB.ranking) return 1;
    	return 0;
    });
    
    // generating two maps:
    // 1) map of the match bets
    // 2) map of the draws, indexes by alias codes
    const betByIdMap = {};
    const oddsByAlias = {};
    const oddIndexByAlias = {};
    let index = 1;
    for(let kb in betListToRender){
    	const btr = betListToRender[kb];
    	betByIdMap[btr.scomSogei + "_" + btr.handicap] = btr;
    	for(let ko in btr.draws){
    		const draw = btr.draws[ko];
    		draw.index = index;
    		for(let ka in draw.aliasList){
    			const alias = draw.aliasList[ka].toLowerCase();
    			oddsByAlias[alias] = draw;
    			oddIndexByAlias[alias] = index;
    		}
    		index ++;
    	}
    }
	window.oddsByAlias = oddsByAlias;
    window.oddIndexByAlias = oddIndexByAlias;
    
	
    function handleKeyMatchField(event){
		// on KEY ENTER, if the alias exists, then select the linked match
		const isEnter = (event.which || event.keyCode) == 13;
		if(isEnter){
			let alias = event.target.value;
			if(alias.length > 0){
				fastbetContext.setSelectedMatch(alias);
				eventBetInput.current.disabled = false;
				eventBetInput.current.focus();
			}
		}
		else if((event.which == 187 || event.which == 107) && goToAmountFieldChar === "PLUS"){
			window.switchFocusOnTheFirstAmountField();
		}
		else if((event.which == 106) && goToAmountFieldChar === "STAR"){
			window.switchFocusOnTheFirstAmountField();
		}
		else if(event.which === 111){
			clearCartAndFocusInMatchAlias();
		} 
    }
    
    function onSubmitEditingMatchField(event){
    	let alias = event.target.value;
		if(alias.length > 0){
			fastbetContext.setSelectedMatch(alias);
			eventBetInput.current.disabled = false;
			eventBetInput.current.focus();
		}
    }
    

    

    function setMatchFieldValue(event,value){
		const isEnter = (event.which || event.keyCode) == 13;
		if(isEnter){
			handleKeyMatchField(event);
		}else{
			if(!isNaN(value)){
				fastbetContext.setMatchFieldText(value);    		
			} 
		}
		  

    }

    function handleFocus(){
    	if(fastbetContext.isInitialized()){
    		fastbetContext.removeMatch();    		
    	}
    	else{
    		fastbetContext.initialize();
    	}
    }

    // toggle the selected draw in the betslip
    function handleSelection(element){
    	const alias = element.value;
    	const values = alias.split("_");
    	// draw code
    	const drawCode = values.pop();
    	// handicap code
    	const handicap = values.pop();
    	// scom code
    	const scom = values.pop();
    	const bet = betByIdMap[scom + "_" + handicap];
  
    	if(bet != null){
    		let descDraw = drawCode;
    		let rawValue = null;
    		for(let k in bet.draws){
    			if(bet.draws[k].id == drawCode){
					descDraw = bet.draws[k].descDraw;
    				rawValue = bet.draws[k].odd;
    			}
    		}
    		if(rawValue){
	     		const event = fastbetContext.getSelectedMatch();
	    		betslipContext.toggleSelectionBetslip(event.pal, 
	    											  event.avv,
	    											  event.alias,
	    											  event.desc,
	    											  event.isLive,
	    											  scom, 
	    											  handicap, 
	    											  bet.descBet, 
	    											  drawCode,
	    											  descDraw,
	    											  rawValue,
	    											  bet.legabile,
	    											  event.sportDesc, 
	    											  event.tournamentDesc,
	    											  event.timestamp,
	    											  event.sportRef,
	    											  event.tournamentRef);   		
    		}

    		clearAliasDrawBuffer();
    		eventSelector.current.focus();
    	}
    }
    
    
    
    function clearCartAndFocusInMatchAlias(){
		clearAliasDrawBuffer();
		eventSelector.current.focus();
    	betslipContext.clearBetslip();
    }
    
    const [drawAliasBuffer, setDrawAliasBuffer] = useState('');
    
    function updateDrawAliasBuffer(value){
    	setDrawAliasBuffer(value.trim().toLowerCase());
    }
    
    function clearAliasDrawBuffer(){
    	setDrawAliasBuffer("");
    	const selectedIndex = eventBetSelector.current.selectedIndex;
		eventBetSelector.current.options[selectedIndex].selected = false;
		eventBetSelector.current.options[0].selected = true;
		clearTimeout(timeoutAliasOdd);
    }
    
    // handler of the keydown event on the bet alias field
    function handleKeyDrawAlias(e) {
        if (betList.length === 0) {
            // The user is typing before the data has been loaded, so we save the keystrokes in a buffer
            if (window.eventsBuffer == null) {
                window.eventsBuffer = [];
            }
            e.persist();
            window.eventsBuffer.push(e);
            return;
        } else if (window.eventsBuffer?.length > 0) {
            // Before we process the current keystroke we need to replay the previous ones
            const events = window.eventsBuffer;
            window.eventsBuffer = [];
            events.forEach(e => handleKeyDrawAlias(e));
        }
    	const isEnter = e.key === "Enter" || e.which == 13;
    	if(isEnter){
    		e.preventDefault();
    		// sends the draw into betslip
    		handleSelection(eventBetSelector.current);
    	}
    	else if(e.which === 111){
    		// char "/"
    		clearCartAndFocusInMatchAlias(); 
    	}
    	else{
    		const isSpaceBar = e.which == 32;
    		if(!isSpaceBar){
    			e.preventDefault();
    			
    			if (e.which < 48) {
			    	if(e.which == 8 || e.which == 46){
			    		// CANC key or BACK key: clear the buffer
			    		clearAliasDrawBuffer();
			    	}
			    	return;
			    }
			    
		    	// key "*"  -> focus in the first avaialable amount field
    		    if(e.which == 106 && goToAmountFieldChar === "STAR"){
			    	// key "+" -> focus in the first avaialable amount field
			    	window.switchFocusOnTheFirstAmountField();
    		    	return; 
    		    }
    			
			    if((e.which == 187 || e.which == 107) && goToAmountFieldChar === "PLUS"){
			    	// key "+" -> focus in the first avaialable amount field
			    	window.switchFocusOnTheFirstAmountField();
			    	return; 
			    }

			    
			    
			    if(drawAliasBuffer != ""){
			    	console.log(drawAliasBuffer);
			    	// searching the odd with its alias
			    	if(oddIndexByAlias[drawAliasBuffer] != null){
			    		const selectedIndex = eventBetSelector.current.selectedIndex;
			    		eventBetSelector.current.options[selectedIndex].selected = false;
			    		let newIndex = oddIndexByAlias[drawAliasBuffer];
			    		eventBetSelector.current.options[newIndex].selected = true;
			    	}
			    }
			    // setting a timeout: after 10 seconds, the buffer must be cleaned
			    clearTimeout(timeoutAliasOdd);
			    timeoutAliasOdd = setTimeout(clearAliasDrawBuffer, 10000);
    		}
    	}
    }
    
    let timeoutAliasOdd = null;

    function openPdf(){
    	let link = conf.fbus[xs_languageCode];    	
    	if(link != null){
    		window.open(link, '_blank', 'location=yes,height=970,width=1020,scrollbars=yes,status=yes');    		
    	}
    }

    let classContainer = "fastbet fbet-unariga widget bg-bianco";
    if(props.showedReservationBox){
    	classContainer = classContainer + ' no-tab-before'; 
    }
   
    return <>
    		{
    			fastbetType === "NONE"?
    				(<></>)
    				:
    				(
    		    	<div className={classContainer}>
    		            {
		    		    <div className="alias-fastbet event-alias-input">
    		            	<i onClick={ openPdf } className="pointer fas fa-question-circle margine-dx-mezzo nero"></i>
    			            <form onSubmit={(e) => {e.preventDefault(); return false;}}>
	    			            <input className="input-personalizzato" autoComplete='off'
	    			            	   type="text" 
	    			            	   id="fastbet-cart-event" 
	    			            	   placeholder={fastbetContext.isLoading()? labels['general.loading'] : labels['general.alias']}
	    			            	   readOnly={!fastbetContext.isDataLoaded()}
	    			            	   value={matchFieldValue}
	    			            	   onChange={e => setMatchFieldValue(e,e.target.value + "") }
	    			            	   onKeyUp={e => handleKeyMatchField(e)}
	    			            	   onFocus={() => handleFocus()}
	    			            	   ref={eventSelector} />
    			            </form>
    		            </div>
    		            }
    		            <div className="draw-alias-input">
    		            	<form onSubmit={(e) => {e.preventDefault(); return false;}}>
	    		            	<input ref={eventBetInput}
	    		            		   value={drawAliasBuffer}
	    		            		   onChange={ e => updateDrawAliasBuffer(e.target.value + "")}
	    		            		   onKeyUp={e => handleKeyDrawAlias(e)}
	    		            		   className="input-personalizzato" 
	    		            		   readOnly={betListToRender.length === 0} 
	    		            		   autoComplete='off' />
    		                </form>
    		            </div>

    		            <select onSelect={e => handleSelection(e.target)} 	 
    		            		ref={eventBetSelector} 
    		            		disabled={betList.length === 0} 
    		            		className="custom-select draw-alias-select">
    		            	<option value="-1"> </option>
    			            {
    				        	Object.keys(betListToRender).map(function(key){
    				        		const bet = betListToRender[key];
  									const draws = bet.draws;
    				        		const betReactKey = bet.scomSogei + "_" + bet.handicap;
    			       			 	return (
    			       		            <optgroup key={betReactKey} label={bet.descBet}>
    			       		            {	
    			       		            	Object.keys(draws).map(function(keyDraw){
    			       		      				const draw = draws[keyDraw]; 
    											const value = bet.scomSogei + "_" + bet.handicap  + "_" + draw.id;;
    			       		            		const index = draw.index;
    					       		        	 return(
    						       		        	 <option index={index}
    						       		        	 		 key={value} 
    						       		        	   		 value={value}
    						       		        	 		 id={"draw-alias-" + value}
    						       		        	 		 scom_sogei={bet.scomSogei}
    						       		        	 		 draw = {draw.id}
    						       		        	 		 handicap={bet.handicap}>
    						       		        	 	{draw.descDraw} : {oddToString(draw.odd)}
    						       		        	 </option>
    					       		        	 )
    					       		         })
    			       		            }
    			       	                </optgroup>
    			       			 	)
    			       		 	})
    			       	 	}
    		            </select>
    		            <div onClick={() => { handleSelection(eventBetSelector.current); }} className="plus-div"> + </div>
    		        </div>
    			)
    		}
    </>

}


export default FastbetCart;